import React from 'react';
import { Link } from 'react-router-dom';
import boleroImage from '../assets/images/bolero-pickup.png';

function CoimbatoreLanding() {
  return (
    <div className="coimbatore-landing-page">
      <section className="page-header parallaxie" style={{backgroundImage: `url(${boleroImage})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">Mini Truck Booking in Coimbatore</h1>
                <nav className="wow fadeInUp">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">home</Link></li>
                    <li className="breadcrumb-item"><Link to="/blog">blog</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Coimbatore</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="city-landing-content" style={{padding: '80px 0'}}>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              
              <div style={{textAlign: 'center', marginBottom: '50px'}}>
                <h2 style={{color: '#E31E24', fontSize: '32px', marginBottom: '20px'}}>
                  Mini Truck Booking in Coimbatore – Fast, Affordable & Reliable Goods Transport
                </h2>
                <p style={{fontSize: '18px', lineHeight: '1.8', maxWidth: '800px', margin: '0 auto'}}>
                  Looking for a mini truck, Tata Ace, Bolero Pickup, or Dost vehicle to move goods anywhere in Coimbatore? With HelloTruck, you can book a verified load vehicle instantly at the best price.
                </p>
              </div>

              <div style={{background: '#f8f9fa', padding: '40px', borderRadius: '15px', marginBottom: '50px'}}>
                <h3 style={{color: '#E31E24', marginBottom: '30px', textAlign: 'center'}}>Why Choose HelloTruck in Coimbatore?</h3>
                <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '25px'}}>
                  <div style={{background: 'white', padding: '25px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
                    <h4 style={{color: '#E31E24', marginBottom: '10px'}}>✓ Instant Online Booking</h4>
                    <p style={{marginBottom: '0', color: '#666'}}>Book your mini truck in 30 seconds through our mobile app or website.</p>
                  </div>
                  <div style={{background: 'white', padding: '25px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
                    <h4 style={{color: '#E31E24', marginBottom: '10px'}}>✓ Affordable Pricing</h4>
                    <p style={{marginBottom: '0', color: '#666'}}>Transparent rates with no hidden charges.</p>
                  </div>
                  <div style={{background: 'white', padding: '25px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
                    <h4 style={{color: '#E31E24', marginBottom: '10px'}}>✓ Verified Local Drivers</h4>
                    <p style={{marginBottom: '0', color: '#666'}}>Experienced drivers who know Coimbatore's routes well.</p>
                  </div>
                  <div style={{background: 'white', padding: '25px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
                    <h4 style={{color: '#E31E24', marginBottom: '10px'}}>✓ Live Tracking</h4>
                    <p style={{marginBottom: '0', color: '#666'}}>Monitor your goods throughout the trip.</p>
                  </div>
                  <div style={{background: 'white', padding: '25px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
                    <h4 style={{color: '#E31E24', marginBottom: '10px'}}>✓ All Major Localities</h4>
                    <p style={{marginBottom: '0', color: '#666'}}>From Gandhipuram to Saravanampatti, we cover every corner of the city.</p>
                  </div>
                </div>
              </div>

              <div style={{marginBottom: '50px'}}>
                <h3 style={{color: '#E31E24', marginBottom: '30px', textAlign: 'center'}}>Available Load Vehicles in Coimbatore</h3>
                <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '25px'}}>
                  <div style={{background: 'linear-gradient(135deg, #E31E24 0%, #c41a1f 100%)', color: 'white', padding: '30px', borderRadius: '15px'}}>
                    <h4 style={{marginBottom: '15px'}}>Tata Ace (Up to 750 kg)</h4>
                    <p style={{marginBottom: '0', fontSize: '15px'}}>Ideal for household goods, parcels, groceries, small business deliveries.</p>
                  </div>
                  <div style={{background: 'linear-gradient(135deg, #E31E24 0%, #c41a1f 100%)', color: 'white', padding: '30px', borderRadius: '15px'}}>
                    <h4 style={{marginBottom: '15px'}}>Dost / Bolero Pickup (1–1.2 ton)</h4>
                    <p style={{marginBottom: '0', fontSize: '15px'}}>Best for construction materials, textile loads, furniture, and bulk items.</p>
                  </div>
                  <div style={{background: 'linear-gradient(135deg, #E31E24 0%, #c41a1f 100%)', color: 'white', padding: '30px', borderRadius: '15px'}}>
                    <h4 style={{marginBottom: '15px'}}>Three-Wheeler Cargo (500–600 kg)</h4>
                    <p style={{marginBottom: '0', fontSize: '15px'}}>Perfect for short-distance and budget deliveries.</p>
                  </div>
                </div>
              </div>

              <div style={{marginBottom: '50px'}}>
                <h3 style={{color: '#E31E24', marginBottom: '30px', textAlign: 'center'}}>Areas We Serve in Coimbatore</h3>
                <p style={{textAlign: 'center', marginBottom: '30px', color: '#666'}}>
                  Our service is available across all major zones, residential areas, industrial hubs, and commercial markets in Coimbatore.
                </p>
                
                <div style={{marginBottom: '30px'}}>
                  <h4 style={{color: '#333', marginBottom: '20px', borderBottom: '2px solid #E31E24', paddingBottom: '10px', display: 'inline-block'}}>Top Areas & Neighbourhoods</h4>
                  <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px'}}>
                    {['Gandhipuram', 'RS Puram', 'Saibaba Colony', 'Peelamedu', 'Avinashi Road', 'Bharathi Nagar', 'Singanallur', 'Ukkadam', 'Town Hall', 'Sidhapudur', 'Tatabad', 'Railway Station', 'Saravanampatti', 'Koundampalayam', 'Thudiyalur', 'Kalapatti', 'Kuniamuthur', 'Selvapuram', 'Ganapathy', 'Hope College', 'Lakshmi Mills', 'Puliakulam', 'Ramanathapuram', 'Sungam', 'Ondipudur', 'Chinniyampalayam', 'Kurichi', 'Perur', 'Vadavalli'].map((area, index) => (
                      <span key={index} style={{background: '#f0f0f0', padding: '8px 15px', borderRadius: '20px', fontSize: '14px'}}>{area}</span>
                    ))}
                  </div>
                </div>

                <div style={{marginBottom: '30px'}}>
                  <h4 style={{color: '#333', marginBottom: '20px', borderBottom: '2px solid #E31E24', paddingBottom: '10px', display: 'inline-block'}}>Industrial & Business Zones</h4>
                  <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px'}}>
                    {['SIDCO Industrial Estate', 'Kurichi Industrial Estate', 'Ettimadai', 'Pollachi Road Industries', 'Saravanampatti IT Parks', 'TIDEL Park', 'ELCOT SEZ', 'Kaniyur Logistics Corridor', 'Neelambur'].map((area, index) => (
                      <span key={index} style={{background: '#E31E24', color: 'white', padding: '8px 15px', borderRadius: '20px', fontSize: '14px'}}>{area}</span>
                    ))}
                  </div>
                </div>

                <div>
                  <h4 style={{color: '#333', marginBottom: '20px', borderBottom: '2px solid #E31E24', paddingBottom: '10px', display: 'inline-block'}}>Suburban & Outskirts</h4>
                  <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px'}}>
                    {['Periyanaickenpalayam', 'Annur', 'Karamadai', 'Madukkarai', 'Thennampalayam', 'Walayar Border', 'Sulur', 'Irugur', 'L&T Bypass Road'].map((area, index) => (
                      <span key={index} style={{background: '#f0f0f0', padding: '8px 15px', borderRadius: '20px', fontSize: '14px'}}>{area}</span>
                    ))}
                  </div>
                </div>
              </div>

              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', marginBottom: '50px'}}>
                <div style={{background: '#fff', border: '2px solid #E31E24', padding: '30px', borderRadius: '15px'}}>
                  <h4 style={{color: '#E31E24', marginBottom: '20px'}}>For Individuals</h4>
                  <ul style={{listStyle: 'none', padding: '0', margin: '0'}}>
                    <li style={{padding: '8px 0', borderBottom: '1px solid #eee'}}>✓ House shifting</li>
                    <li style={{padding: '8px 0', borderBottom: '1px solid #eee'}}>✓ Transporting furniture & appliances</li>
                    <li style={{padding: '8px 0', borderBottom: '1px solid #eee'}}>✓ Two-wheeler transport</li>
                    <li style={{padding: '8px 0', borderBottom: '1px solid #eee'}}>✓ Shop purchases delivery</li>
                    <li style={{padding: '8px 0'}}>✓ Bulk shopping pickup (Metro, D-Mart, etc.)</li>
                  </ul>
                </div>
                <div style={{background: '#fff', border: '2px solid #E31E24', padding: '30px', borderRadius: '15px'}}>
                  <h4 style={{color: '#E31E24', marginBottom: '20px'}}>For Businesses</h4>
                  <ul style={{listStyle: 'none', padding: '0', margin: '0'}}>
                    <li style={{padding: '8px 0', borderBottom: '1px solid #eee'}}>✓ Textile load transport</li>
                    <li style={{padding: '8px 0', borderBottom: '1px solid #eee'}}>✓ Retail & wholesale supply chain</li>
                    <li style={{padding: '8px 0', borderBottom: '1px solid #eee'}}>✓ E-commerce deliveries</li>
                    <li style={{padding: '8px 0', borderBottom: '1px solid #eee'}}>✓ Industrial raw materials</li>
                    <li style={{padding: '8px 0'}}>✓ FMCG/food distribution</li>
                  </ul>
                </div>
              </div>

              <div style={{background: '#f8f9fa', padding: '40px', borderRadius: '15px', marginBottom: '50px'}}>
                <h3 style={{color: '#E31E24', marginBottom: '30px', textAlign: 'center'}}>Mini Truck Booking Charges in Coimbatore</h3>
                <p style={{textAlign: 'center', marginBottom: '20px'}}>We ensure transparent & competitive rates. Pricing depends on:</p>
                <div style={{display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '15px', marginBottom: '20px'}}>
                  <span style={{background: '#E31E24', color: 'white', padding: '10px 20px', borderRadius: '25px'}}>Distance</span>
                  <span style={{background: '#E31E24', color: 'white', padding: '10px 20px', borderRadius: '25px'}}>Vehicle Type</span>
                  <span style={{background: '#E31E24', color: 'white', padding: '10px 20px', borderRadius: '25px'}}>Load Weight</span>
                  <span style={{background: '#E31E24', color: 'white', padding: '10px 20px', borderRadius: '25px'}}>Waiting Time</span>
                </div>
                <p style={{textAlign: 'center', fontWeight: 'bold', color: '#E31E24'}}>Get an instant quote in the app!</p>
              </div>

              <div style={{marginBottom: '50px'}}>
                <h3 style={{color: '#E31E24', marginBottom: '30px', textAlign: 'center'}}>How to Book a Mini Truck in Coimbatore?</h3>
                <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px'}}>
                  <div style={{textAlign: 'center', padding: '25px'}}>
                    <div style={{width: '60px', height: '60px', background: '#E31E24', color: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px', fontSize: '24px', fontWeight: 'bold'}}>1</div>
                    <h5 style={{marginBottom: '10px'}}>Enter Locations</h5>
                    <p style={{color: '#666', fontSize: '14px'}}>Enter Pickup & Drop Location</p>
                  </div>
                  <div style={{textAlign: 'center', padding: '25px'}}>
                    <div style={{width: '60px', height: '60px', background: '#E31E24', color: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px', fontSize: '24px', fontWeight: 'bold'}}>2</div>
                    <h5 style={{marginBottom: '10px'}}>Choose Vehicle</h5>
                    <p style={{color: '#666', fontSize: '14px'}}>Select Vehicle Type</p>
                  </div>
                  <div style={{textAlign: 'center', padding: '25px'}}>
                    <div style={{width: '60px', height: '60px', background: '#E31E24', color: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px', fontSize: '24px', fontWeight: 'bold'}}>3</div>
                    <h5 style={{marginBottom: '10px'}}>View Price</h5>
                    <p style={{color: '#666', fontSize: '14px'}}>View Price Estimate</p>
                  </div>
                  <div style={{textAlign: 'center', padding: '25px'}}>
                    <div style={{width: '60px', height: '60px', background: '#E31E24', color: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px', fontSize: '24px', fontWeight: 'bold'}}>4</div>
                    <h5 style={{marginBottom: '10px'}}>Confirm & Track</h5>
                    <p style={{color: '#666', fontSize: '14px'}}>Confirm Booking & Track Live</p>
                  </div>
                </div>
                <p style={{textAlign: 'center', marginTop: '20px', fontSize: '18px'}}>That's it — your driver arrives in minutes!</p>
              </div>

              <div style={{background: '#E31E24', color: 'white', padding: '50px', borderRadius: '15px', textAlign: 'center'}}>
                <h3 style={{marginBottom: '15px'}}>HelloTruck – Your Local Transport Partner in Coimbatore</h3>
                <p style={{marginBottom: '25px', fontSize: '16px'}}>Whether you're sending a single box or multiple tons of material, HelloTruck ensures safe, fast, and affordable goods movement across Coimbatore.</p>
                <div>
                  <a 
                    href="https://play.google.com/store/apps/details?id=com.hellotruck.customer&hl=en_IN" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-block',
                      background: 'white',
                      color: '#E31E24',
                      padding: '15px 35px',
                      borderRadius: '5px',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                      marginRight: '15px',
                      marginBottom: '10px'
                    }}
                  >
                    Download App
                  </a>
                  <a
                    href="https://digital.hellotruck.in/login/user-login"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-block',
                      background: 'transparent',
                      color: 'white',
                      padding: '15px 35px',
                      borderRadius: '5px',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                      border: '2px solid white',
                      marginBottom: '10px'
                    }}
                  >
                    Book Now
                  </a>
                </div>
              </div>

              <div style={{marginTop: '40px', paddingTop: '30px', borderTop: '1px solid #ddd'}}>
                <Link to="/blog" style={{color: '#E31E24', textDecoration: 'none', fontWeight: 'bold'}}>
                  ← Back to Blog
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CoimbatoreLanding;
